import styles from "./CalculationScreen.module.css";

/** The sentence under a position — the same one the position's `title` carries (design §9; §15.4: both). */
export function PriceSourceNote({ sentence }: { sentence: string }) {
  return (
    <span className={styles.sourceNote}>
      <span className="label">Quelle</span>
      <span>{sentence}</span>
    </span>
  );
}
